/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Siden blev ikke fundet",
  "ComingSoon": "Kommer snart",
  "YesanPersonalFinance": "Yesan, personlig økonomi",
  "Yesan": "Yesan",
  "PersonalFinance": "Privatøkonomi",
  "YesanDownload": "Yesan Download",
  "ThisWebsiteUsesCookies": "Vi bruger cookies til at indsamle og analysere oplysninger om vores websteds ydeevne og brug og til at levere funktioner til sociale medier. Ved at fortsætte accepterer du vores",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Bliv økonomisk fri",
  "inStepsAndActions": "i 8 trin og 3 handlinger.",
  "TrackPlanAnalyze": "Spor. Planlæg. Analyser.",
  "FTrack": "1. Spor",
  "FPlan": "2. Planlæg",
  "FAnalyze": "3. Analysér",
  "Features": "Funktioner",
  "FeaturesSubHeading": "For nybegyndere, der allerede har styr på økonomien, er dette den app, du skal bruge for at blive økonomisk fri.",
  "ManageAccounts": "Administrer konti",
  "CashLiquidFixedAssetsLiabilities": "Kontanter, likvide midler, anlægsaktiver og passiver.",
  "TrackTransactions": "Spor transaktioner",
  "IncomesExpensesTransferInvestments": "Indtægter, udgifter, overførsler, investeringer.",
  "ImportExport": "Import/eksport",
  "YourDataAlwaysAccessible": "Dine data er altid tilgængelige.",
  "PlanYourFreedom": "Planlæg din frihed",
  "StepsAwayFromFI": "8 skridt væk fra økonomisk uafhængighed.",
  "BudgetsAndGoals": "Budgetter og mål",
  "CheckYourProgressAndAchieve": "Tjek dine fremskridt, og nå dine økonomiske mål.",
  "DashboardAndAnalytics": "Dashboard og analyse",
  "ReviewLearnOptimizeWith": "Gennemgå, lær, optimer med diagrammer, indsigt, værktøjer.",
  "Security": "Sikkerhed",
  "MilitaryGradeEncryption": "Kryptering af militærstandard, understøttelse af biometri, data gemt på dine enheder.",
  "OfflineMode": "Offline-tilstand",
  "YourDataAlwaysAccessibleAndModif": "Dine data er altid tilgængelige og kan ændres.",
  "Track": "Spor",
  "Income": "Indtægter",
  "Expense": "Udgifter",
  "Transfer": "Overførsel",
  "transactionsAndManageAccounts": "transaktioner og administrer forskellige konti:",
  "checkings": "Kontrol",
  "savings": "Opsparing",
  "realEstate": "Fast ejendom",
  "stocks": "Aktiemarkeder",
  "bonds": "Obligationer",
  "crypto": "Krypto",
  "notes": "Sedler, kontanter Tegnebog",
  "envelopes": "Konvolutter",
  "privateEquity": "Privat egenkapital",
  "metal": "Metal",
  "retirement": "Pensionering",
  "lifeInsurance": "Livsforsikring",
  "intellectualProperty": "Intellektuel ejendom",
  "otherLiquidAsset": "Andre likvide aktiver",
  "otherFixedAsset": "Andre anlægsaktiver",
  "mortgage": "Realkreditlån",
  "loan": "Forbrugslån",
  "creditCard": "Kreditkort",
  "otherLiability": "Andre passiver",
  "AccountsManagement": "Administration af konti",
  "MultipleAccountsTypesAndGrouping": "Flere kontotyper og gruppering",
  "LinkAccounts": "Link konti fra dine institutioner (kun tilgængelig i visse lande)",
  "SmartAccounts": "Smarte konti",
  "AddEditDeleteTransactions": "Tilføj / Rediger / Slet transaktioner",
  "TickVerifiedTransactions": "Sæt kryds ved bekræftede transaktioner",
  "CategorizeTransactions": "Kategoriser transaktioner",
  "TagTransactions": "Tag transaktioner",
  "TrackKakeiboType": "Spor Kakeibo-type",
  "TrackInvestments": "Spor investeringer (kun tilgængelig i visse lande)",
  "ImportFromCSVFile": "Importer hele eller trinvise transaktioner fra CSV-fil",
  "ExportToCSVFile": "Eksporter transaktioner til CSV-fil",
  "stepsTowardsFIPlanBudgetingReachGoals": "8 trin mod økonomisk uafhængighed, detaljeret budgettering, nå dine økonomiske mål hurtigere.",
  "levelsTowardsFI": "8 niveauer mod økonomisk uafhængighed",
  "EstablishBudgetsPer": "Opret budgetter pr.",
  "account": "konto",
  "accountType": "Kontotype",
  "KakeiboType": "Kakeibo type",
  "category": "Kategori",
  "tag": "Tag",
  "label": "label",
  "TrackBudgetsPerFrequency": "Spor budgetter pr. frekvens",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Opret mål for forbrug, balance, cashflow, handlinger",
  "TrackGoalsProgress": "Spor fremskridt med mål",
  "ReviewLearnOptimizeWithReportsCharts": "Gennemgå, lær, optimer med rapporter, diagrammer, tendenser, indsigt, værktøjer.",
  "Dashboard": "Dashboard",
  "FSNetWorth": "Finansielle opgørelser: Nettoværdi",
  "FSPnL": "Finansielle opgørelser: Resultatopgørelse / Profit & Loss",
  "FSBalanceSheetAssetsLiabilities": "Finansielle opgørelser: Balance, aktiver, passiver",
  "FSCashFlow": "Finansielle opgørelser: Pengestrømsopgørelse, debet, kredit, strømme",
  "FSFlows": "Finansielle opgørelser: Strømme",
  "FSRatios": "Finansielle opgørelser: Forholdstal",
  "TrendsMonthEnd": "Tendenser ved månedens udgang: Indtægter og udgifter, pengestrømme",
  "TrendsPerformance": "Tendenser for præstation: År til år, måned til måned, uge til uge",
  "IncomeTrendsPer": "Indkomsttendenser pr.",
  "SpendingTrendsPer": "Tendenser for udgifter pr.",
  "RecurringItemsIE": "Tilbagevendende poster: Indtægter og udgifter",
  "DebtProgressTrends": "Udviklingen i gæld",
  "KakeiboMTDReviewTrends": "Kakeibo: MTD-gennemgang, sidste måned, tendenser",
  "FIWCLE": "Økonomisk uafhængighed: Vægdiagram, udgifter efter livsenergi",
  "DebtPaydownSnowballAvalanche": "Nedbringelse af gæld: Snebold, Lavine",
  "FullyCustomizableAnalyticsRange": "Fuldt tilpasselig analyse af tidsinterval",
  "ContactUs": "Kontakt os",
  "Privacy": "Beskyttelse af personlige oplysninger",
  "Terms": "Betingelser",
  "About": "Om dette",
  "IAgreeToThe": "Jeg er enig i",
  "AndThe": "og",
  "PrivacyPolicy": "Privatlivspolitik",
  "TermsOfUse": "Vilkår for brug",
  "DigitalSoftwareExperienceTagline": "Digital softwareoplevelse til den moderne verden",
  "DigitalExperience": "Digital oplevelse",
  "SoftwareForTheModernWorld": "Software til den moderne verden",
  "MobileApplications": "Mobile applikationer",
  "forConnectedAndOfflineHumans": "til opkoblede og offline mennesker",
  "CloudSaaS": "SaaS i skyen",
  "ResponsiveAndWebServices": "Responsive og webtjenester",
  "PersonalFinanceServices": "Tjenester til personlig økonomi",
  "YS_p1": "Yesan er en dynamisk softwarevirksomhed, der specialiserer sig i udvikling af banebrydende mobilapplikationer skræddersyet til forbrugere. Med en skarp forståelse af de skiftende behov og præferencer hos nutidens teknologikyndige brugere, er Yesan dedikeret til at skabe intuitive, engagerende og funktionsrige mobiloplevelser, der beriger brugernes liv.",
  "YS_p2": "Kernen i Yesans mission er en ubarmhjertig forpligtelse til innovation og kreativitet, og hvert produkt er omhyggeligt udformet til at levere problemfri funktionalitet og en enestående brugeroplevelse.",
  "PersonalFinanceApplication": "Applikation til personlig økonomi",
  "YPF_p1": "Yesan, Personal Finance er en banebrydende mobilapplikation til privatøkonomi, der er designet til at give brugerne omfattende værktøjer til økonomistyring lige ved hånden. Med en elegant og intuitiv brugerflade tilbyder Yesan, Personal Finance en holistisk tilgang til økonomistyring, der henvender sig til brugere på alle niveauer af økonomisk forståelse.",
  "YPF_p2": "Nøglefunktionerne omfatter budgetsporing, udgiftskategorisering og transaktionsovervågning i realtid, så brugerne nemt kan få indsigt i deres forbrugsvaner. Appen tilbyder også tilpassede budgetmuligheder, så brugerne kan sætte økonomiske mål og spore deres fremskridt over tid.",
  "YPF_p3": "Yesan, Personal Finance prioriterer desuden sikkerhed og anvender avancerede krypteringsprotokoller til at beskytte brugernes følsomme økonomiske oplysninger. Med sikkerhedsforanstaltninger på bankniveau kan brugerne trygt linke deres konti og synkronisere transaktioner uden at gå på kompromis med privatlivets fred.",
  "YPF_p4": "Yesan, Personal Finance går videre end basal budgettering ved at tilbyde indsigtsfulde analyser og personlige anbefalinger til optimering af økonomiske beslutninger. Uanset om det handler om at identificere potentielle besparelsesmuligheder, overvåge investeringsporteføljer eller håndtere strategier for tilbagebetaling af gæld, giver appen skræddersyet indsigt, der hjælper brugerne med at nå deres økonomiske mål.",
  "Discover": "Opdag",
  "Firstname": "Fornavn",
  "Lastname": "Efternavn",
  "Company":"Virksomhed",
  "Subject": "Emne",
  "Email": "E-mail",
  "Message": "Besked",
  "ThankYouForContactingUs": "Tak, fordi du kontaktede os",
  "ValidFirstnameRequired": "Gyldigt fornavn er påkrævet.",
  "ValidLastnameRequired": "Gyldigt efternavn er påkrævet.",
  "ValidEmailAddressRequired": "Indtast venligst en gyldig e-mailadresse.",
  "ValidSubjectRequired": "Vælg venligst et gyldigt emne.",
  "ValidMessageRequired": "Indtast venligst en gyldig besked.",
  "UnableToSendTheFormPleaseRetryLater": "Formularen kunne ikke sendes, prøv igen senere.",
  "Information": "Information",
  "Sales":"Salg",
  "Support": "Støtte",
  "Press": "Tryk på",
  "Partnership": "Partnerskab",
  "Other": "Andet",
  "Blog":"Blog",

  "Accept":"Accepter",
  "Decline":"Afvis",

  "WorklogCalendar":"Worklog-kalender til Jira",

  "DirectlyAccessibleInProjectApps":"Direkte tilgængelig i projektapps",
  "VisualizeWhereYouSpentYourTime":"Visualiser, hvor du har brugt din tid",
  "AllYourWorklogsInACalendar":"Alle dine arbejdslogs i en kalender",
  "MonthSummary":"Oversigt over måneden",
  "CheckIfYouForgotToLogTime":"Tjek, om du har glemt at logge tid.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Få direkte adgang til emnerne og opdater tiden",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Klik på worklog-elementet for at få direkte adgang til problemerne og redigere din registrerede tid.",
  "AlsoAvailableInDarkMode":"Også tilgængelig i mørk tilstand",
  "DirectlyLogWorkOnTheCalendarVisually":"Log arbejde direkte på kalenderen visuelt",
  "ClickOnTheCalendarToCreateNewWorklog":"Klik på kalenderen for at oprette en ny arbejdslog",

  "AppsForAtlassian":"Apps til Atlassian",
  "YCL_p1":"Visualiser alle dine worklogs i en kalender med måneds-, uge-, arbejdsuge- og dagsvisning.",
  "YCL_p2":"Log arbejde direkte fra kalenderen ved visuelt at vælge tidsrummet.",
  "YCL_p3":"Identificer, hvis du har glemt at registrere tid til dine timesedler.",
  "YCL_p4":"Tilgængelig på dit sprog: Engelsk (UK), engelsk (US), kinesisk (forenklet), kinesisk (traditionelt), dansk, estisk, finsk, fransk, islandsk, italiensk, japansk, koreansk, nederlandsk, norsk, polsk, portugisisk (Brasilien), portugisisk (Portugal), russisk, spansk, svensk, tyrkisk, tjekkisk, tysk og ungarsk.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Finansiel portefølje til Jira",
  "BringRealFinancialPortfolio":"Få ægte finansiel porteføljestyring i Jira. Hold styr på budgetter, CapEx/OpEx og projektomkostninger ét sted.",
  "YFPAboutQ":"Hvor meget koster vores Jira-projekter os egentlig?",
  "YFPAbout":"Finansiel portefølje til Jira\nFinansledere og PMO'er har svært ved at besvare et simpelt spørgsmål:\nHvor meget koster vores Jira-projekter os egentlig?\nJira sporer arbejde.\nFinansafdelingen sporer budgetter.\nDenne app forbinder endelig de to.\n\nFinansiel portefølje forvandler Jira til en letvægts PPM + finansiel planlægningsplatform — uden behov for dyre virksomhedsværktøjer.",
  "YFPPorfolioQ":"Porteføljebudgetter og sporing",
  "YFPPorfolioP":"Opret porteføljer på tværs af flere Jira-projekter, og definer: Budgetbeløb, valuta, datointerval, inkluderede projekter, teams. Spor de faktiske omkostninger automatisk, efterhånden som arbejdet udføres i Jira.",
  "YFPPorfolioListQ":"Porteføljer",
  "YFPPorfolioListP":"Opret finansielle porteføljer, der kombinerer flere Jira-projekter, og se med det samme: Budget vs. faktiske omkostninger, projektforbrug i realtid, opdeling af CapEx vs. OpEx, omkostninger pr. opgave og projekt, eksporterbare finansielle rapporter. Alt drevet direkte af Jira-arbejdslogfiler.",
  "CostQ":"Automatisk omkostningsberegning",
  "CostP":"Gør tidsregistrering til reelle økonomiske data. Appen: Læser Jira-arbejdslogfiler, anvender timepriser, beregner reelle projektomkostninger dagligt. Ingen regneark. Intet manuelt arbejde.",
  "RatesQ":"Satser",
  "RatesP":"Indstil timesats pr. projekt, team, globalt",
  "ReportQ":"CSV-finansrapportering",
  "ReportP":"Eksporter porteføljefinansdata på få sekunder. Perfekt til: Økonomiteams, CFO-rapportering, budgetplanlægning, revisionsstøtte",
  "SettingsQ":"CapEx vs. OpEx-klassificering",
  "SettingsP":"Understøtter regnskabs- og revisionskrav. Klassificer arbejde i: Kapitaliserbar udvikling (CapEx), operationelt arbejde (OpEx). Generer eksporterbare rapporter, der er klar til økonomiteams."
};

export const documents = {
};
